export const featureFlagsDetails = [
    {
      "ID": 101,
      "Name": "WIP",
      "Type": "boolean"
    },
    {
      "ID": 102,
      "Name": "BETA_Youtube",
      "Type": "array",
      "Condition": "out"
    },
    {
      "ID": 103,
      "Name": "Transaction_List",
      "Type": "array",
      "Condition": "in"
    },
    {
      "ID": 104,
      "Name": "BETA_Whatsapp_linking",
      "Type": "boolean"
    },
    {
      "ID": 105,
      "Name": "Branding_Seller",
      "Type": "array",
      "Condition": "in"
    },
        {
      "ID": 106,
      "Name": "service_pos",
      "Type": "array",
      "Condition": "in"
    },
    {
      "ID": 107,
      "Name": "service_job_with_accounts",
      "Type": "array",
      "Condition": "out"
    },
    {
      "ID": 108,
      "Name": "hide_servicenear_oldSwitchUI",
      "Type": "array",
      "Condition": "in"
    }
  ]
  